
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as TrendEqualIconComponent } from "./trend-equal-icon.svg";

export const TrendEqualIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <TrendEqualIconComponent {...props} />;
};
